/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import throttle from 'lodash/throttle';
import { Container, Row, Column } from '../../../styles/Grid';
import Spacer from '../../ui/Spacer';
// import CtaLink from '../../ui/CtaLink';
import BackToTop from '../../ui/BackToTop';
import DotComponent from '../../ui/DotComponent';
// import {
//   types,
//   sizes,
//   decorations,
//   arrows,
//   arrowPositions,
// } from '../../ui/CtaLink/types';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import SiteMapBlock from './SitemapBlock';
import get from 'lodash/get';
import * as styles from './index.styles';
import StackGrid from 'react-stack-grid';
import { Icon } from '../../ui/Icon';

const defaultData = {
  Headline: {
    value: '',
  },
  BackLink: {
    value: {
      href: null,
      text: null,
      target: null,
    },
  },
  SiteMap: {
    value: [],
  },
};

export class HtmlSitemap extends SafePureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shouldRenderBackToTop: false,
      isSitemapPage: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.throttledHandleScroll, true);

    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);

    this.checkIsSitemapPage();
  }
  checkIsSitemapPage = () => {
    let isSitemapPage = window.location.pathname.includes('/sitemap');
    this.setState({ isSitemapPage: isSitemapPage });
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledHandleScroll);
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  handleScroll = () => {
    const lastScrollY = window.scrollY;
    this.setState({ shouldRenderBackToTop: lastScrollY > 500 });
  };

  throttledHandleScroll = throttle(this.handleScroll, 50);

  getColumnWidth = () => {
    const { windowWidth } = this.state;
    if (windowWidth >= 1440) {
      return '25%';
    }
    if (windowWidth >= 1024) {
      return '25%';
    }
    if (windowWidth >= 768) {
      return '25%';
    }
    return '100%';
  };

  goBack = () => {
    if (window.history.length === 1) {
      window.location = window.location.origin;
    } else {
      window.history.back();
    }
  };

  safeRender() {
    // const { t } = this.props;
    // console.log('** props', this.props);
    const { isSitemapPage, shouldRenderBackToTop } = this.state;

    const fields = defaultsDeep(this.props.fields, defaultData);
    const { Headline, BackLink, SiteMap, RenderBackButton } = fields;
    const hasGeoHeadline = Boolean(Headline.value);
    const headlineDefault = { value: 'Sitemap' };
    const shouldRenderBacklink = Boolean(BackLink.value.href);
    const blocksData = SiteMap.value;
    const blockColumns = blocksData.map((block, index) => {
      const phase = get(block, 'phase', 'office in');
      const links = get(block, 'links', []);
      const Children = get(block, 'Children', []);

      return (
        <div
          // cols={{ sm: 6, md: 4, lg: 4, xl: 3 }}
          css={styles.blockItem}
          key={index}
        >
          <SiteMapBlock
            links={links}
            phase={phase}
            Children={Children}
            isSitemapPage={isSitemapPage}
          />
        </div>
      );
    });

    return (
      <Spacer>
        <Container css={styles.mainContainer}>
          <Row>
            <Column>
              <h1 css={styles.headline}>
                <Text
                  field={hasGeoHeadline ? fields.Headline : headlineDefault}
                />
                <DotComponent />
              </h1>
            </Column>
          </Row>

          {shouldRenderBacklink && (
            <Row>
              <Column css={styles.backlink}>
                <div css={[styles.goBackButtonContainer]}>
                  <button css={styles.goBackButton} onClick={this.goBack}>
                    <Icon name="arrow-left" />
                    <span css={styles.goBackButtonLabel}>Back</span>
                  </button>
                </div>
              </Column>
            </Row>
          )}

          {/* <Row css={styles.blocksContainer}>{blockColumns}</Row> */}
          <div css={styles.stackGridHolder}>
            <StackGrid
              // more...
              columnWidth={this.getColumnWidth()}
            >
              {blockColumns}
            </StackGrid>
          </div>

          {shouldRenderBackToTop && <BackToTop css={[styles.backToTop]} />}
        </Container>
      </Spacer>
    );
  }
}

HtmlSitemap.displayName = 'HtmlSitemap';

HtmlSitemap.propTypes = {
  fields: PropTypes.shape({
    Headline: PropTypes.shape({
      value: PropTypes.string,
    }),
    BackLink: PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
      target: PropTypes.string,
    }),
    SiteMap: PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
};

export default withNamespaces()(HtmlSitemap);
